module.exports = "https://web-assets.ifttt.com/packs/media/onboarding_recommendations/onboarding-pro-a5892054.svg";